import type { ReactNode } from 'react';

export const DAAS_PROJECT_TYPE = 'daas-project';
export const DAAS_APPLICATION_TYPE = 'daas-application';
export const DAAS_APPLICATION_SET_TYPE = 'daas-application-set';

export const ALLOWED_DAAS_TYPES = [
  DAAS_PROJECT_TYPE,
  DAAS_APPLICATION_TYPE,
  DAAS_APPLICATION_SET_TYPE,
] as const;

export type DaaSType = (typeof ALLOWED_DAAS_TYPES)[number];

export const isDaaSType = (value: unknown): value is DaaSType =>
  typeof value === 'string' &&
  (ALLOWED_DAAS_TYPES as readonly string[]).includes(value);

export const asDaaSType = (
  value: unknown,
  fallback: DaaSType = DAAS_APPLICATION_TYPE,
): DaaSType => (isDaaSType(value) ? value : fallback);

export type DaaSContentProps = {
  initialKindFilter: string;
  title: string;
  children?: ReactNode;
};

export interface KaapTenant {
  name: string;
}

export interface ClusterConfig {
  id?: string;
  name: string;
  server: string;
  namespace?: string;
  // TODO: add this field to catalog-info.yaml for Application and ApplicationSet
  catalogRef?: string;
  kaapTenant?: KaapTenant;
  namespaces?: string[];
  allowedNamespaces?: string[];
}

export interface SyncPolicyOptions {
  prune?: boolean;
  selfHeal?: boolean;
  allowEmpty?: boolean;
}

export interface KeyValueEntry {
  key: string;
  value: string;
}

export interface SyncPolicy {
  autoSync?: {
    enabled: boolean;
    options?: SyncPolicyOptions;
  };
  autoCreateNamespace?: {
    enabled: boolean;
  };
  syncOptions?: KeyValueEntry[];
}

export interface ApplicationMetadata {
  annotations?: KeyValueEntry[];
  labels?: KeyValueEntry[];
}

export type SourceConfiguration = {
  deploymentType: 'manifests' | 'helm' | 'kustomize';
  repoURL: string;
  targetRevision: string;
  path?: string;
  chart?: string;
  helm?: {
    releaseName: string;
    valueFiles: string[];
    valuesObject?: Record<string, unknown>;
    ignoreMissingValueFiles: boolean;
    valuesSource?: {
      repoURL: string;
      targetRevision: string;
    };
  };
};
